import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SeekForward15Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SeekForward15",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M29.36 15.5c-.21-.13-.45-.21-.69-.21-.72-.01-1.31.57-1.32 1.29-.05 1.04-.25 2.07-.59 3.06-2.02 5.92-8.46 9.09-14.38 7.07a11.2 11.2 0 0 1-6.71-6.05c-.19-.42-.35-.84-.49-1.28-1.59-5.13.61-10.67 5.29-13.32l.19-.1c3.51-1.9 7.76-1.79 11.17.28l.55.34-2.68 1.43c-.18.1-.28.29-.26.5.01.2.15.38.34.44l6.17 2.09c.14.04.28.03.41-.04a.47.47 0 0 0 .24-.31l1.68-6.29c.05-.2-.03-.41-.19-.53a.485.485 0 0 0-.55-.05L24.9 5.23A13.95 13.95 0 0 0 9.42 3.67l-.6.32a13.99 13.99 0 0 0-5.96 16.84c.11.3.21.62.36.9 1.58 3.56 4.6 6.28 8.29 7.5 1.23.42 2.51.66 3.8.73 7.71.39 14.28-5.55 14.67-13.26 0-.48-.23-.94-.64-1.2Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.88 18.78v1.36h4.16v-1.36h-1.36v-6.69h-.83l-2.16 1.12.33 1.29 1.19-.61v4.89zM19.46 18.72c-.23.13-.49.19-.77.19-.32 0-.6-.07-.87-.21-.26-.14-.57-.4-.9-.77l-.82.89c.3.45.67.79 1.12 1.03.44.25.95.36 1.49.36s1.04-.12 1.47-.37c.44-.25.78-.58 1.04-.99.26-.43.38-.9.38-1.42s-.11-.96-.34-1.36-.53-.71-.92-.94a2.5 2.5 0 0 0-1.31-.34c-.22 0-.44.02-.67.08-.2.05-.39.1-.56.18l.23-1.58h3.29v-1.3h-4.39l-.46 3.42.7.95c.27-.14.5-.25.68-.31.17-.07.33-.11.46-.14.14-.02.28-.03.43-.03.28 0 .53.07.75.19.22.13.4.3.52.52.13.22.2.46.2.74s-.07.5-.21.71q-.195.33-.54.51Z"
    })]
  }));
};